import {pointAddedIcon} from '@img/index.js'

// Min-lead-time / already-passed warning for the recommended pickup. Renders nothing
// unless `timeError`. Shared by the booking Smart Time step and edit/confirm DateTimeSection.
export default function TimeErrorWarning({timeError}) {
    if (!timeError) return null
    return (
        <div className="hopn-smart-time-date-warning error">
            <img decoding="async" src={pointAddedIcon} alt="Warning"/>
            <span>{timeError}</span>
        </div>
    )
}
